import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-address-field-nullify',
  templateUrl: './address-field-nullify.component.html',
  standalone: true,
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldNullifyComponent implements AfterViewInit {
  @Input() fieldControl: FormControl;
  @Input() checkBoxControl: FormControl;

  constructor() {
  }

  ngAfterViewInit(): void {
    this.fieldControl.setValue(this.checkBoxControl.value);
    this.checkBoxControl.valueChanges.subscribe(value => {
      this.fieldControl.setValue(value);
    });
  }

}
